import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BuyContractService } from '../buy-contract.service';
import { AllocationHistoryEntry, BuyAllocationStatus, CardHistory } from '../buy-contract.type';

export interface CardHistoryDialogData {
  cardId: string;
}

@Component({
  selector: 'app-card-history-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './card-history-dialog.html',
  styleUrl: './card-history-dialog.scss'
})
export class CardHistoryDialog implements OnInit {
  history: CardHistory | null = null;
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CardHistoryDialogData,
    private dialogRef: MatDialogRef<CardHistoryDialog>,
    private service: BuyContractService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.getCardHistory(this.data.cardId).subscribe({
      next: res => {
        this.history = res;
        this.loading = false;
      },
      error: () => {
        this.snackBar.open('Error loading card history', 'Close', { duration: 5000 });
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  getAllocationStatusClass(status: BuyAllocationStatus): string {
    switch (status) {
      case 'Locked': return 'status-locked';
      case 'Bought': return 'status-bought';
      case 'Released': return 'status-released';
      case 'Expired': return 'status-expired';
    }
  }

  formatDate(d?: string): string {
    if (!d) return '—';
    return new Date(d).toLocaleString();
  }

  trackByAllocationId(_index: number, entry: AllocationHistoryEntry): string {
    return entry.id;
  }
}
